import { AkeneoSyncAPI } from '@/api';
import {
  IAkeneoCleanSyncDTO,
  IAkeneoSyncEntityDTO,
  IAkeneoSyncProductsDTO,
  IAkeneoSyncSpecificProductDTO,
  IBaseAkeneoSyncResponse,
  IGetCleanupDatabaseDataResponse,
  IGetEntitiesInfoResponse,
  IProductSyncResponse,
} from '@/models/akeneoSync.model';
import { IApiError } from '@/models/apiError.model';
import { formatApiError } from '@/utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { SLICE_NAME } from './models';

export const getEntities = createAsyncThunk<IGetEntitiesInfoResponse, void, { serializedErrorType: IApiError }>(
  `${SLICE_NAME}/getEntities`,
  async () => {
    const response = await AkeneoSyncAPI.getEntities();
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getProductSync = createAsyncThunk<IProductSyncResponse, void, { serializedErrorType: IApiError }>(
  `${SLICE_NAME}/getProductSync`,
  async () => {
    const response = await AkeneoSyncAPI.getProductSync();
    return response.data;
  },
  { serializeError: formatApiError },
);

export const syncEntity = createAsyncThunk<
  IBaseAkeneoSyncResponse,
  IAkeneoSyncEntityDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/syncEntity`,
  async (data) => {
    const response = await AkeneoSyncAPI.syncEntity(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const syncByEntity = createAsyncThunk<
  IBaseAkeneoSyncResponse,
  IAkeneoSyncProductsDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/syncProducts`,
  async (data) => {
    const response = await AkeneoSyncAPI.syncProducts(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const syncSpecificProduct = createAsyncThunk<
  IBaseAkeneoSyncResponse,
  IAkeneoSyncSpecificProductDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/syncSpecificProduct`,
  async (data) => {
    const response = await AkeneoSyncAPI.syncSpecificProduct(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const cleanSync = createAsyncThunk<
  IBaseAkeneoSyncResponse,
  IAkeneoCleanSyncDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/cleanSync`,
  async (data) => {
    const response = await AkeneoSyncAPI.cleanSync(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getCleanupDatabaseData = createAsyncThunk<
  IGetCleanupDatabaseDataResponse,
  void,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/getCleanupDatabaseData`,
  async () => {
    const response = await AkeneoSyncAPI.getCleanupDatabaseData();
    return response.data;
  },
  { serializeError: formatApiError },
);
